var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "faq-block" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        _vm._l(_vm.faqs, function(faq) {
          return _c(
            "div",
            { key: faq.question, staticClass: "faq-block__question-answer" },
            [
              _c("div", { staticClass: "faq-block__question" }, [
                _c("p", [
                  _c("span", { staticClass: "sk-fqa-q" }, [_vm._v("Q: ")]),
                  _vm._v(" " + _vm._s(faq.question)),
                  _c("span", { staticClass: "sk-fqa-arrow" })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq-block__answer" }, [
                _c("p", { domProps: { innerHTML: _vm._s(faq.answer) } }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "faq-block__link",
                  domProps: { innerHTML: _vm._s(faq.link) }
                })
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }